"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.h5plusReday = void 0;
var system_1 = require("./system");
var route_1 = require("./route");
var barcode_1 = require("./barcode");
var image_1 = require("./image");
var share_1 = require("./share");
var h5plusCarrier_1 = __importDefault(require("./h5plusCarrier"));
var customH5plus = {
    isInApp: system_1.isInApp,
    isIos: system_1.isIos,
    isAndroid: system_1.isAndroid,
    xStreamId: system_1.xStreamId,
    navigate: route_1.navigate,
    scanQRCode: barcode_1.scanQRCode,
    saveImageUrl: image_1.saveImageUrl,
    saveImageBase64: image_1.saveImageBase64,
    shareWxMiniprogram: share_1.shareWxMiniprogram,
    navigateToWxMiniprogram: route_1.navigateToWxMiniprogram,
    routerReplaceAll: route_1.routerReplaceAll
};
var h5plus = {};
if ((0, system_1.isInApp)()) {
    h5plus = customH5plus;
}
else {
    h5plus = h5plusCarrier_1.default;
}
function h5plusReday() {
    return new Promise(function (resolve, reject) {
        try {
            if ((0, system_1.isInApp)()) {
                resolve(customH5plus);
            }
            else {
                document.addEventListener('plusready', function () {
                    if ((0, system_1.isInApp)()) {
                        resolve(customH5plus);
                    }
                    else {
                        resolve(h5plusCarrier_1.default);
                    }
                });
            }
        }
        catch (error) {
            reject(error);
        }
    });
}
exports.h5plusReday = h5plusReday;
exports.default = h5plus;
//# sourceMappingURL=index.js.map